import { render, staticRenderFns } from "./CardConfigList.vue?vue&type=template&id=f82a317a&scoped=true&"
import script from "./CardConfigList.vue?vue&type=script&lang=js&"
export * from "./CardConfigList.vue?vue&type=script&lang=js&"
import style0 from "./CardConfigList.vue?vue&type=style&index=0&id=f82a317a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a317a",
  null
  
)

export default component.exports